<template>
  <div class="nav-wrap" :class="color == 'white' ? 'white-font' : ''">
    <div class="link-wrap">
      <!-- <router-link to="/product">FIT</router-link> -->
      <router-link to="/">
        <img
          id="ID_Speediance_Button"
          name='"SPEEDIANCE"按钮'
          v-if="color == 'black'"
          class="logo"
          @click="toHome"
          src="/static/images/index/icon_logo.png"
          alt="logo"
        />
        <img
          id="ID_Speediance_Button"
          name='"SPEEDIANCE"按钮'
          v-else
          class="logo"
          @click="toHome"
          src="/static/images/index/icon_logo_white.png"
          alt="logo"
        />
      </router-link>
    </div>
    <div class="link-wrap">
      <!-- <router-link to="/">我的账户</router-link> -->
      <router-link
        id="ID_speedianceNews_Button"
        name="“资讯”按钮"
        to="/together"
        style="font-weight: 500"
        >资讯</router-link
      >
      <div class="img-wrap">
        <img
          id="ID_Navigation_Button"
          name="“导航栏”按钮"
          @click="openMenu"
          class="tab-img"
          :src="
            color == 'white'
              ? '../../static/images/index/icon_tab_white.png'
              : '../../static/images/index/icon_tab.png'
          "
          alt=""
        />
      </div>
    </div>
    <!-- 跳转菜单组件 -->
    <Menu ref="menuDialog" />
  </div>
</template>

<script>
import Menu from "./Menu.vue";
export default {
  props: {
    color: {
      default: "black",
    },
  },
  components: {
    Menu,
  },
  data() {
    return {};
  },
  methods: {
    toHome() {
      this.$router.push({
        path: "/",
      });
    },
    openMenu() {
      this.$refs.menuDialog.show();
    },
  },
};
</script>

<style lang="less" scoped>
.logo {
  width: 225px;
  height: 23px;
}
.active {
  background: transparent !important;
  color: unset !important;
}
.white-font {
  color: #ffffff !important;
}
.nav-wrap {
  box-sizing: border-box;
  width: 100%;
  font-size: 30px;
  font-weight: 400;
  color: #000000;
  line-height: 42px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  padding-top: 31px;
  padding-bottom: 31px;
  position: fixed;
  z-index: 888;
  top: 0;
  left: 0;
  overflow: visible;
  .link-wrap {
    display: flex;
    align-items: center;
    a {
      padding: 0 30px;
      color: unset;
    }
    .img-wrap {
      padding: 0 30px;
      .tab-img {
        width: 36px;
        height: 20px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Nav.vue